module.exports = __webpack_public_path__ + "static/media/MetaStructures.131b7819.txt";